import { render, staticRenderFns } from "./TipoDocumentoCombobox.vue?vue&type=template&id=1affa5fd&scoped=true&"
import script from "./TipoDocumentoCombobox.vue?vue&type=script&lang=js&"
export * from "./TipoDocumentoCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1affa5fd",
  null
  
)

export default component.exports